// Shop links authored in Storyblok are free input from the content team, so
// only hand the native app URLs that point at a Dartshopper shop over https.
// Covers every country domain (dartshopper.nl, dartshopper.de, ...) and its
// subdomains (www., m., ...).
const SHOP_HOST = /(^|\.)dartshopper\.[a-z]{2,}(\.[a-z]{2,})?$/i

/**
 * Resolve a Storyblok link field to a shop URL the native app can open, or
 * null when it is empty or not a Dartshopper https URL. Accepts a Multilink
 * object (`{ linktype: 'url', url }`) as well as a plain string.
 */
export function resolveShopUrl(link) {

    const raw = typeof link === 'string' ? link : link?.url || link?.cached_url
    if (typeof raw !== 'string' || !raw.trim()) return null

    let url
    try {
        url = new URL(raw.trim())
    } catch {
        return null
    }

    if (url.protocol !== 'https:' || !SHOP_HOST.test(url.hostname)) return null

    return url.href
}
